const config = {
  client: 1,
  title: "思路行外贸线索管理系统",
  version: "0.0.1",
};

export default config;
